import { assetFieldRegistry } from './AssetFields'
import { ImageEditorField } from './ImageEditorField'
import { basicFieldRegistry, SliderField } from './BasicFields'
import { collectionFieldRegistry } from './CollectionFields'
import { ImagePickerField } from './ImagePickerField'
import { ThumbnailGridField } from './ThumbnailGridField'
import { VideoPanel } from '../components/v2form/VideoPanel'

export const fieldRegistry = Object.freeze({
  ...basicFieldRegistry,
  ...assetFieldRegistry,
  'image-editor': ImageEditorField,
  'video-editor': VideoPanel,
  ...collectionFieldRegistry,
})

/**
 * Presentation-only controls a schema may opt into via `field.ui.control`.
 *
 * Kept separate from fieldRegistry because these are alternate *renderings* of an
 * existing field type, not new types: `design.layout` stays a `select` as far as the
 * engine, validation and the preview runtime are concerned. An unknown control name
 * falls back to the field's own type, so a schema can name a control this editor does
 * not have yet without breaking.
 */
export const controlRegistry = Object.freeze({
  'percentage-slider': SliderField,
  'thumbnail-grid': ThumbnailGridField,
  'image-picker': ImagePickerField,
  'video-picker': VideoPanel,
})
